import { render } from "./ReviewDetail.vue?vue&type=template&id=7b65a422&scoped=true"
import script from "./ReviewDetail.vue?vue&type=script&lang=js"
export * from "./ReviewDetail.vue?vue&type=script&lang=js"

import "./ReviewDetail.vue?vue&type=style&index=0&id=7b65a422&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b65a422"]])

export default __exports__